import Demo from "./demo";
import Emg from "./emergency";
import RealtimeCall from "./realtimeCall";

const plugins = {
   Demo,
   Emg,
   RealtimeCall
};

export default plugins;
